import axios from 'axios'

export const BASE = import.meta.env.VITE_API_BASE_URL ?? ''

export const api = axios.create({
  baseURL: `${BASE}/api/v1`,
  headers: { 'Content-Type': 'application/json' },
})

const TOKEN_KEY = 'orderbook_token'

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (token) => localStorage.setItem(TOKEN_KEY, token),
  clear: () => localStorage.removeItem(TOKEN_KEY),
}

api.interceptors.request.use((config) => {
  const token = tokenStore.get()
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // An expired token should drop the user at login rather than render a
    // half-broken page full of 401s.
    if (error.response?.status === 401 && !location.pathname.startsWith('/login')) {
      tokenStore.clear()
      location.href = '/login'
    }
    return Promise.reject(error)
  },
)

/** Human-readable message from a FastAPI error response. */
export function errorMessage(error) {
  const detail = error?.response?.data?.detail
  if (typeof detail === 'string') return detail
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg
  return error?.message ?? 'Something went wrong'
}
